import './Banner.css.ts.vanilla.js';

var banner = 'Banner_banner__1dfrm4q2';
var bannerContainer = 'Banner_bannerContainer__1dfrm4q1';
var bannerFooter = 'Banner_bannerFooter__1dfrm4qd';
var bannerVariant = {
  info: 'Banner_bannerVariant_info__1dfrm4q5 Banner_banner__1dfrm4q2',
  warn: 'Banner_bannerVariant_warn__1dfrm4q6 Banner_banner__1dfrm4q2',
  error: 'Banner_bannerVariant_error__1dfrm4q7 Banner_banner__1dfrm4q2',
  success: 'Banner_bannerVariant_success__1dfrm4q8 Banner_banner__1dfrm4q2'
};
var closeButton = 'Banner_closeButton__1dfrm4qe';
var copy = 'Banner_copy__1dfrm4q9';
var description = 'Banner_description__1dfrm4qc';
var dismissible = 'Banner_dismissible__1dfrm4q4';
var icon = 'Banner_icon__1dfrm4qa';
var noIcon = 'Banner_noIcon__1dfrm4q3';
var title = 'Banner_title__1dfrm4qb';

export { banner, bannerContainer, bannerFooter, bannerVariant, closeButton, copy, description, dismissible, icon, noIcon, title };
